import { useEkardoMutation } from '@netfront/ekardo-content-library';

import { CREATE_CODE_ASSET } from './UseCreateCodeAsset.graphql';

const useCreateCodeAsset = (options) => {
  const { mutation, onCompleted, onError, token } = options ?? {};

  const [executeCreateCodeAsset, { loading: isLoading }] = useEkardoMutation({
    mutation: mutation ?? CREATE_CODE_ASSET,
    options: {
      onCompleted: (data) => {
        if (!onCompleted) {
          return;
        }

        const {
          asset: { createAsset: returnedAsset },
        } = data;

        onCompleted({
          returnedAsset,
        });
      },
      onError,
    },
    token,
  });

  const handleCreateCodeAsset = ({ projectId, type, fileName, contentType, alt, fileSizeInBytes }) => {
    executeCreateCodeAsset({
      variables: {
        asset: {
          projectId,
          type,
          fileName,
          contentType,
          alt,
          fileSizeInBytes,
        },
      },
    });
  };

  return {
    handleCreateCodeAsset,
    isLoading,
  };
};

export { useCreateCodeAsset };
